












import Vue, { PropType } from 'vue'
import { mapActions } from 'vuex'
import XIcon from '@/components/atoms/Icon/XIcon.vue'
import { Dictionary } from 'vue-router/types/router'

export interface DrawerItem {
  id?: string
  icon: { name: string }
  title: string
  routeName?: string
  routeParam?: Dictionary<string>
}

export default Vue.extend({
  name: 'XDrawerItem',
  components: { XIcon },
  props: {
    item: {
      type: Object as PropType<DrawerItem>,
      required: true,
    },
  },
  methods: {
    ...mapActions('drawer', ['toggleDrawer']),
    handleClick() {
      this.toggleDrawer()
      this.$emit('press', this.item)
      if (this.item.routeName) {
        if (this.$router.currentRoute.name !== this.item.routeName) {
          this.$router.push({
            name: this.item.routeName,
            params: this.item.routeParam,
          })
        }
      }
    },
  },
})
